if (!window.Eurus.loadedScript.has('image-comparison.js')) {
  window.Eurus.loadedScript.add('image-comparison.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xImageComparison', (sectionId, layout) => ({
        init() {
          // Set initial values immediately on init
          this.$nextTick(() => {
            const slider = this.$el.querySelector('.before-after__slider');
            if (slider && this.$refs.image) {
              const initialValue = parseFloat(slider.value);
              if (layout === "horizontal") {
                this.$refs.image.style.setProperty('--compare_' + sectionId, initialValue + '%');
              } else {
                this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, (100 - initialValue) + '%');
              }
            }
          });
        },
        load(e) {
          if (layout == "horizontal") {
            this.$refs.image.style.setProperty('--compare_' + sectionId, e.target.value + '%');
          } else {
            this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, (100 - e.target.value) + '%');
          }
        },
        resizeWindow(el) {
          addEventListener("resize", () => {
            this.setMinMaxInput(el);
          });
        },
        disableScroll(el) {
          let isfocus = true;
          window.addEventListener('wheel', () => {
            if (isfocus) {
              el.blur();
              isfocus = false;
            }
          }, { passive: true });
        },
        setMinMaxInput(el) {
          el.min = 0;
          el.max = 100;
        },
        animateValue(el) {
          // Wait for next tick to ensure everything is rendered
          this.$nextTick(() => {
            if (!this.$refs.image) {
              console.error('Image ref not found');
              return;
            }

            const targetValue = parseFloat(el.value);
            let currentValue = layout === "horizontal" ? 100 : 100;
            const totalDuration = 1000;
            let startTime = null; 
          
            const easeInOutSlowEnd = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          
            const step = (timestamp) => {
              if (!startTime) startTime = timestamp;
              const elapsedTime = timestamp - startTime;
              const progress = Math.min(elapsedTime / totalDuration, 1);
          
              const easedProgress = easeInOutSlowEnd(progress);
          
              if (layout === "horizontal") {
                currentValue = 100 + (targetValue - 100) * easedProgress; 
                el.value = currentValue.toFixed(2);
                this.$refs.image.style.setProperty('--compare_' + sectionId, currentValue + '%');
          
                if (progress < 1) {
                  requestAnimationFrame(step);
                } else {
                  el.value = targetValue; 
                  this.$refs.image.style.setProperty('--compare_' + sectionId, targetValue + '%');
                }
              } else {
                const targetVerticalValue = 100 - targetValue;
                currentValue = 100 + (targetVerticalValue - 100) * easedProgress; 
                el.value = (100 - currentValue).toFixed(2);
                this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, currentValue + '%');
          
                if (progress < 1) {
                  requestAnimationFrame(step);
                } else {
                  el.value = targetValue;
                  this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, targetVerticalValue + '%');
                }
              }
            };
          
            requestAnimationFrame(step);
          });
        }        
      }));
    });
  });
}